import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import ViewCafeteriaInvoice from '../../../components/Storage/ViewStorageInvoice'
import { showInIQD } from '../../../customFunction/Numeral/CurrencyFormat'
import { DropdownMenu, DropdownMenuContent, DropdownMenuLabel, DropdownMenuTrigger } from '../../../src/components/shadui/ui/dropdown-menu'
import { IoMdMore } from 'react-icons/io'
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../../../src/components/shadui/ui/alert-dialog'
import { buttonVariants } from '../../../src/components/shadui/ui/button'
import axios from 'axios'
import { t } from 'i18next'

function CafeteriaViewInvoice() {
    const data = useLocation().state.data
    const [alertOpen, setAlertOpen] = useState(false)
    const history = useHistory()

    const columns = [
        {
            label: "image",
            value: (a) => (
                <img
                    alt=''
                    className='object-contain w-20 h-20'
                    src={a.productDetails.imageUri}
                />
            ),
        },
        { label: "name", value: (a) => a.productDetails.name },
        { label: "quantity", value: (a) => a.quantity },

        {
            label: "price",
            value: (a) => showInIQD(a.price, "IQD"),
        },
        {
            label: "totalPrice",
            value: (a) => showInIQD(a.price * a.quantity, "IQD"),
        },
    ]

    const onDeleteItem = async () => {
        // console.log('delete')
        try {
            await axios.delete('/cafeteria-storage-activities/' + data._id)
            history.goBack()

        } catch (e) {
            console.log(e)
            alert('error')
        }
    }

    return (
        <div className='flex flex-col items-center justify-center flex-1 bg-white' >
            <ViewCafeteriaInvoice columns={columns} id='cafeteria' invoiceProducts={data?.items} >
                <div className='flex flex-col w-full ' >
                    <div className='flex items-center justify-between' >
                        <h1 className='text-4xl font-bold' >{t('products')} </h1>
                        <DropdownMenu>
                            <DropdownMenuTrigger>
                                <IoMdMore size={30} />
                            </DropdownMenuTrigger>
                            <DropdownMenuContent>
                                <DropdownMenuLabel className='text-red-500 cursor-pointer' onClick={() => setAlertOpen(true)} >{t('delete')}</DropdownMenuLabel>
                                <AlertDialog open={alertOpen} >
                                    <AlertDialogContent>
                                        <AlertDialogHeader>
                                            <AlertDialogTitle>{t('pleaseMakeSureThisAction')}</AlertDialogTitle>
                                            <AlertDialogDescription>
                                                {t('thisActionCannotBeUndone_storage')}
                                            </AlertDialogDescription>
                                        </AlertDialogHeader>
                                        <AlertDialogFooter>
                                            <AlertDialogCancel onClick={() => { setAlertOpen(false) }} >{t('cancel')}</AlertDialogCancel>
                                            <AlertDialogAction className={buttonVariants({ variant: "destructive" })} onClick={onDeleteItem}>{t('delete')}</AlertDialogAction>
                                        </AlertDialogFooter>
                                    </AlertDialogContent>
                                </AlertDialog>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>
                    <h1 className='mt-5 font-medium' >By: {data.admin.name} </h1>
                </div>

            </ViewCafeteriaInvoice>
        </div>
    )
}

export default CafeteriaViewInvoice
